import {http} from '@/http/index.js';

async function sendComplaint(consumerId) {
  return http.post(`/consumers/${consumerId}/complaints`);
}

export {sendComplaint};
